import React from 'react';
import { Check, Circle, Loader2 } from 'lucide-react';

export default function ReelCreating({ status }) {
  const qc = status === 'quality_check' || status === 'ready';
  const ready = status === 'ready';
  const rows = [
    ['Reference analysed', true],
    ['Footage ready', true],
    ['Creating edit', true],
    ['Final check', qc],
    ['Ready', ready]
  ];
  return (
    <div className="mx-auto max-w-md py-8" role="status" aria-live="polite">
      <Loader2 className="mx-auto animate-spin text-purple-300" size={52} />
      <h2 className="mt-5 text-center text-3xl font-bold">Creating Your Reel</h2>
      <p className="mt-2 text-center text-gray-400">You can leave this screen. Your Reel will keep creating.</p>
      <div className="mt-8 space-y-3 rounded-2xl border border-gray-800 bg-gray-900 p-5">
        {rows.map(([label, complete], index) => {
          const active = !complete && rows.slice(0, index).every((row) => row[1]);
          return <div key={label} className={`flex items-center gap-3 ${complete ? 'text-white' : active ? 'text-purple-200' : 'text-gray-600'}`}>{complete ? <span className="flex h-7 w-7 items-center justify-center rounded-full bg-green-500 text-gray-950"><Check size={16} /></span> : active ? <Loader2 className="animate-spin text-purple-300" size={27} /> : <Circle size={27} />}<span>{label}</span></div>;
        })}
      </div>
    </div>
  );
}

